import type { Item } from '@bc/discovery/ui/filters';

export const filterFeatureFlagConfig: Record<string, (item: Item) => boolean> = {};
